import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=c9cbcc80&scoped=true&"
import script from "./AgeVerification.vue?vue&type=script&lang=ts&"
export * from "./AgeVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=c9cbcc80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cbcc80",
  null
  
)

export default component.exports